import React, { ReactNode } from 'react'
import { SocietyWebsiteBottomBar } from '../SocietyWebsiteBottomBar'
import { ISocietyWebsiteModel } from '../../../../interfaces/models/societies-websites.interfaces'

interface SocietyWebsiteBaseProps {
  children: ReactNode
  website: ISocietyWebsiteModel
  isValid?: boolean
  loading?: boolean
  className?: string
}

export const SocietyWebsiteBase = ({
  children,
  website,
  loading,
  isValid,
  className,
}: SocietyWebsiteBaseProps): React.ReactNode => {
  return (
    <div
      className={`flex h-4/6 w-full flex-col justify-between
        ${className ?? ''}`}
    >
      {children}
      <SocietyWebsiteBottomBar
        website={website}
        isValid={isValid}
        loading={loading}
      />
    </div>
  )
}
